module.exports = {
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/search/index/type/label',
      method: 'get',
      param: {},
      flagKey: 'indexType',
      id: 'name',
      name: 'name',
      isLimit: true
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name',
      isLimit: true
    }
  ],
  filterForm: [
    {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '平台',
      width: '250px',
      intintValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'indexType',
      label: '名称',
      width: '250px',
      intValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'brand',
      label: '品牌',
      width: '250px',
      intValue: '',
      children: []
    }, {
      type: 'datetimerange',
      // dateType: 'date',
      clearable: true,
      id: 'timeLimit',
      label: '日期',
      startTimeId: 'dateTimeStartTime',
      endTimeId: 'dateTimeEndTime',
      width: '450px',
      // intValue: ['', '']
      intValue: []
    }
  ],
  sortRules: [
    {
      name: '降序',
      id: '1'
    }, {
      name: '升序',
      id: '2'
    }
  ],
  tableBtn: [
    {
      id: 'check',
      name: '查看详情',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    },
    {
      id: 'edit',
      name: '修改数据',
      dataStatus: '1',
      isNoConfirm: true // 不需要弹窗询问
    }
  ],
  tableHead: [
    {
      label: '序号',
      key: '$index',
      width: '60'
    }, {
      label: '平台',
      key: 'platform',
      width: '120'
    }, {
      key: 'indexType',
      label: '名称'
    }, {
      label: '品牌',
      key: 'brand',
      width: '120'
    }, {
      key: 'date',
      label: '日期'
    }, {
      key: 'searchIndex',
      label: '指数'
    }, {
      key: 'founderName',
      label: '创建人'
    }, {
      key: 'founderTime',
      label: '创建时间'
    }, {
      key: 'modifierName',
      label: '修改人'
    }, {
      key: 'updateTime',
      label: '修改时间'
    }
  ]
}
